var Geometry = require("./src/basicGeometry.js");
require("./src/utils.js");
require("./src/complexGeometry.js");
require("./src/3d/geometry3d.js");
require("./src/shapeGeometry.js");
require("./src/approximationUtils.js");
require("./src/jstsGeometry.js");
require("./src/clipperGeometry.js");
// require("./src/deprecatedGeometry.js");
module.exports.Coord        = Geometry.Coord;
module.exports.Coord3d      = Geometry.Coord3d;
module.exports.Line         = Geometry.Line;
module.exports.Ellipse      = Geometry.Ellipse;
module.exports.Ray          = Geometry.Ray;
module.exports.Segment      = Geometry.Segment;
module.exports.BoundingBox  = Geometry.BoundingBox;

module.exports.Path          = Geometry.Path;
module.exports.PointSet      = Geometry.PointSet;
module.exports.Trace         = Geometry.Trace;
module.exports.Polygon       = Geometry.Polygon;
module.exports.ComplexPolygon= Geometry.ComplexPolygon;
module.exports.MultiPolygon  = Geometry.MultiPolygon;

module.exports.ExportThreeJSObj  = Geometry.ExportThreeJSObj;
module.exports.TriangleMesh  = Geometry.TriangleMesh;

module.exports.Transform    = Geometry.Transform;
module.exports.collinear    = Geometry.collinear;
module.exports.pointLineSide = Geometry.pointLineSide;

module.exports.ellipseToArcsApproximation = Geometry.ellipseToArcsApproximation;
module.exports.bezierToArcsApproximation = Geometry.bezierToArcsApproximation;
module.exports.ellipseToArcsApproximation = Geometry.ellipseToArcsApproximation;
module.exports.arcThrough3Points = Geometry.arcThrough3Points;

module.exports.jstsPolyToSVG = Geometry.jstsPolyToSVG;
module.exports.drawJstsPolygon = Geometry.drawJstsPolygon;

module.exports.Union = Geometry.Union;

module.exports.buffer           = require("./src/buffer.js");

module.exports.ObjFileExport = require("./src/3d/objFileExport.js");
